// extracted by mini-css-extract-plugin
module.exports = {"toBeCenter":"VideoPlayer_toBeCenter__j_G3C","videoPlayer":"VideoPlayer_videoPlayer__U6IZG"};